<template>
    <section class="section-head" id="section0">
        <div class="main-wrap">
            <transition name="fade-bottom">
                <div class="section-head__content" v-if="show">
                    <div class="section-head__info head-info">
                        <h1 class="head-info__title">
                            Таймлайн растущего ребенка: от&nbsp;сказок на&nbsp;ночь к&nbsp;универу и&nbsp;собственной квартире
                        </h1>
                        <p class="head-info__desc">
                            Тысячи игрушек, сотни разных хобби, ежедневная проверка родителей (и&nbsp;себя самого) на&nbsp;прочность. Детские площадки, садик, тусовки во&nbsp;дворе и&nbsp;школы. Пикабу и&nbsp;<a href="https://pikabu.ru/story/dofenialedenzayred_bosnykiknloolnaes_prv_eiy__4637659" class="app__link app__link--red" target="_blank">ПИК</a> прослеживают жизнь ребенка от&nbsp;рождения и&nbsp;до момента, когда он&nbsp;поступает в&nbsp;вуз (а&nbsp;может, в&nbsp;колледж) и&nbsp;готов начать самостоятельную взрослую жизнь.
                        </p>
                        <icon-arrow class="head-info__icon" v-scroll-to="'#block-promo'" />
                    </div>
                </div>
            </transition>
        </div>
    </section>
</template>

<script>
export default {
    components: {
    },
    props: {
    },
    data () {
        return {
            show: false
        }
    },
    mounted () {
        this.$nextTick(() => {
            this.show = true
        })
    }
}
</script>

<style scoped lang="stylus">
    .section-head {
        background no-repeat center center / cover url(./assets/main-bg-mobile.jpg)

        +retina() {
            background-image url(./assets/main-bg-mobile@2x.jpg)
        }

        +layout-md-and-up() {
            background-image url(./assets/main-bg-desktop.jpg)
        }

        +retina() {
            background-image url(./assets/main-bg-desktop@2x.jpg)
        }

        &__content {
            display flex
            padding-left 3rem
            flex-direction column
            justify-content center
            align-items flex-end
            padding-bottom 2rem

            +layout-md-and-up() {
                min-height 63rem
                padding 6.6rem 0 5rem 0
                height calc(100vh + 1px)
            }
        }
    }

    .head-info {
        padding 2rem
        position relative
        margin-right -1rem
        background-color $color-yellow
        margin-top 8rem

        +layout-sm-and-up() {
            margin-bottom: 0
        }

        +layout-md-and-up() {
            margin-top 0
            flex 1 1 49.2rem
            max-height 49.2rem
            max-width 73.7rem
            display flex
            flex-flow column nowrap
            justify-content space-around
            padding 2.1rem 5.8rem 6.6rem 8.6rem
        }

        +layout-l-and-up() {
            margin-right -3.8rem
        }

        &__title {
            font-size: 2.2rem
            line-height: 2.6rem
            letter-spacing: 0.23px
            color: $color-white
            font-weight 600

            @media (min-width: 500px) {
                font-size 3.6rem
                line-height 3.9rem
            }

            +layout-sm-and-up() {
                line-height 1
                font-size 4.4rem
                letter-spacing 0.48px
            }
        }

        &__desc {
            margin 2rem 0 0 0
            font-size 1.5rem
            line-height 1.47
            letter-spacing 0.16px
            color $color-text

            +layout-sm-and-up() {
                font-size 1.6rem
                line-height 2.5rem
            }

            +layout-md-and-up() {
                margin 2rem 0 0 0
            }
        }
        &__icon {
            display none

            +layout-md-and-up() {
                display block
                width 2.2rem
                height 3.9rem
                margin-top 2.7rem
                position absolute
                bottom 2.7rem
                margin-left: -2px;
                animation translate 1.5s ease-in-out infinite forwards

                &:hover {
                    fill: $color-blue
                    cursor pointer
                    animation-play-state paused
                    opacity:0.7
                }
            }
        }
    }

    .fade-bottom-enter-active,
    .fade-bottom-leave-active {
        transition transform .8s cubic-bezier(0.25, 0.1, 0.18, 1.6) .4s, opacity 0.5s ease .4s
    }
    .fade-bottom-enter,
    .fade-bottom-leave-to {
        opacity 0
        transform translate(0, 50px)
    }
</style>
